<template>
    <DsTooltip
        v-if="tooltipText"
        :tooltipText="tooltipText"
        tooltipLocation="top"
    >
        <BadgeCore
            :icon
            :text
            :variant
        />
    </DsTooltip>
    <BadgeCore
        v-else
        :icon
        :text
        :variant
    />
</template>

<script setup lang="ts">
import BadgeCore, { type BadgeCoreProps } from '@/components/design-system/badge/BadgeCore.vue';
import DsTooltip from '@/components/design-system/tooltip/DsTooltip.vue';

export interface DsBadgeProps extends BadgeCoreProps {
    tooltipText?: string;
}

defineProps<DsBadgeProps>();
</script>
